import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { useEffect } from "react"
import { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"

const Hero = () => {
  const [index, setIndex] = useState(0)

  const query = graphql`
    {
      strapiHomePage {
        hero_heading
        hero_description
        hero_images {
          hero_image {
            localFile {
              publicURL
            }
          }
        }
      }
    }
  `

  const data = useStaticQuery(query)

  const {
    strapiHomePage: { hero_heading, hero_description, hero_images },
  } = data

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(oldIndex => {
        let index = oldIndex + 1
        if (index > hero_images.length - 1) {
          index = 0
        }
        return index
      })
    }, 7000)

    return () => clearInterval(interval)
  }, [index, hero_images.length])

  return (
    <div className="hero-bg">
      <Container className="hero my-5">
        <Row className="align-items-center">
          <Col
            lg={6}
            className="order-lg-1 order-2 text-md-center text-lg-left"
          >
            <h1>{hero_heading}</h1>
            <p>{hero_description}</p>
          </Col>
          <Col lg={6} className="hero-img-container order-lg-2 order-1">
            <img
              src={hero_images[index].hero_image.localFile.publicURL}
              alt="hero-img"
            />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Hero
